import { createSlice } from "@reduxjs/toolkit";

export const initOrder = {
  productId: "",
  quantity: "1",
  image: "",
  name: "",
  logo: null,
  color: null,
  size: null,
  selected: [],
  product: {},
  lengthVari: null,
  optional: "",
  imageIndex: 0,
};

const initialState = {
  isAuth: false,
  activeKey: "1",
  productOrder: initOrder,
  selectedAdress: null,
};

export const generatesSlice = createSlice({
  name: "generates",
  initialState,
  reducers: {
    setIsAuth: (state, action) => {
      state.isAuth = action.payload;
    },

    setActiveKey: (state, action) => {
      state.activeKey = action.payload;
    },

    setProductOrder: (state, action) => {
      state.productOrder = {
        ...state.productOrder,
        ...action.payload,
      };
    },
    setInitOrder: (state) => {
      state.productOrder = initOrder;
    },
  },
});

export const { setIsAuth, setActiveKey, setProductOrder, setInitOrder } =
  generatesSlice.actions;

export default generatesSlice.reducer;
